import { render, staticRenderFns } from "./data-chart-card.vue?vue&type=template&id=94517404&scoped=true"
import script from "./data-chart-card.vue?vue&type=script&lang=js"
export * from "./data-chart-card.vue?vue&type=script&lang=js"
import style0 from "./data-chart-card.vue?vue&type=style&index=0&id=94517404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94517404",
  null
  
)

export default component.exports